<!-- Add Gateways modal -->

<!-- <div class="modal-dialog modal-dialog-centered"> -->
<div class="modal-content">
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title"> {{ gatewayUpdateData?.id? 'Update Gateway' : 'Add Gateway' }} </h5>
        <button type="button" (click)="dismissModal()" class="btn-close text-white" aria-label="Close"></button>
    </div>
    <div class="modal-body">
        <form class="form-horizontal" [formGroup]="creategatewayForm">
            <div class="mb-3">
                <label>Gateway Id <span class="required">*</span></label>
                <input type="text" class="form-control" formControlName="gatewayAddress" id="gatewayAddress" />
                @if(submitted && gatewayControls['gatewayAddress'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['gatewayAddress'].errors['required']){
                    <div>{{fileValidations.gateWayAddress.required}}</div>}

                    @if(gatewayControls['gatewayAddress'].errors['minlength']){
                    <div>{{fileValidations.gateWayAddress.min_required_Validations}}</div>
                    }
                    @if(gatewayControls['gatewayAddress'].errors['maxlength']){
                    <div>{{fileValidations.gateWayAddress.min_required_Validations}}</div>
                    }
                    @if(gatewayControls['gatewayAddress'].errors['pattern'] && !iswirdeCommunication) {
                    <div>{{fileValidations.gateWayAddress.pattern}}</div>
                    }
                    @if(gatewayControls['gatewayAddress'].errors['pattern'] && iswirdeCommunication){
                    <div>{{fileValidations.gateWayAddress.pattern_new}}</div>
                    }


                </div>}


            </div>
            <div class="mb-3">
                <label>Project Name <span class="required">*</span></label>
                <ng-select [items]="listofProjects
                    " formControlName="projectId" (change)="valueChange($event)" [multiple]="false" bindLabel="name"
                    bindValue="id" [placeholder]="'Select...'" [clearable]="false"></ng-select>
                @if(submitted && gatewayControls['projectId'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['projectId'].errors['required']){
                    <div>{{fileValidations.project.required}}</div>}

                </div>}

            </div>


            <div class="mb-3" style="margin-top: 30px;">
                <label for="b">Is Wired Gateway<span class="required">*</span></label>&nbsp;&nbsp;
                <ui-switch [ngClass]="{
                    'switch-checked': creategatewayForm.controls['isWiredGateway'].value,
                    'switch-unchecked': !creategatewayForm.controls['isWiredGateway'].value
                  }" formControlName="isWiredGateway" [uncheckedLabel]="'No'" [checkedLabel]="'Yes'" size="small"
                    class="me-1" (change)="onSwitchChange($event)">
                </ui-switch>
            </div>

            <div class="mb-3">
                <label>Device Sr No <span class="required">*</span></label>
                <input type="text" class="form-control" formControlName="serialNumber" id="serialNumber" />
                @if(submitted && gatewayControls['serialNumber'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['serialNumber'].errors['required']){
                    <div>{{fileValidations.serialNumber.required}}</div>}

                    @if(gatewayControls['serialNumber'].errors['pattern'] && iswirdeCommunication){
                    <div>{{fileValidations.serialNumber.pattern}}</div>
                    }
                    @if(gatewayControls['serialNumber'].errors['maxlength']){
                    <div>{{fileValidations.serialNumber.min_required_Validations}}</div>
                    }
                    @if(gatewayControls['serialNumber'].errors['pattern'] && !iswirdeCommunication) {
                    <div>{{fileValidations.serialNumber.pattern_new}}</div>
                    }

                </div>} 

            </div>
            <div class="mb-3" *ngIf="this.gatewayUpdateData?.id">
                <label>Running On</label>
                <input type="text" class="form-control" formControlName="runningOn" id="runningOn" />


            </div>
            <div class="mb-3">
                <label>Shaft</label>
                <input type="text" class="form-control" formControlName="shaft" id="shaft" />
                @if(submitted && gatewayControls['shaft'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['shaft'].errors['pattern']){
                    <div>{{fileValidations.shaft.pattern}}</div>}

                </div>}

            </div>
            <div class="mb-3">
                <label>Block Name</label>
                <input type="text" class="form-control" formControlName="blockName" id="blockName" />
                @if(submitted && gatewayControls['blockName'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['blockName'].errors['pattern']){
                    <div>{{fileValidations.blockName.pattern}}</div>}

                </div>}

            </div>
            <div class="mb-3">
                <label>Floor Number</label>
                <input type="text" class="form-control" formControlName="floorNum" id="floorNum" />
                @if(submitted && gatewayControls['floorNum'].errors){
                <div class="invalid-feedback">
                   
                    @if(gatewayControls['floorNum'].errors['pattern']){
                    <div>{{fileValidations.floorNum.pattern}}</div>}
                </div>}

            </div>
            <div class="mb-3">
                <label>Network Status</label>
                <input type="text" class="form-control" formControlName="networkStatus" id="networkStatus" />

                @if(submitted && gatewayControls['networkStatus'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['networkStatus'].errors['pattern']){
                    <div>{{fileValidations.networkStatus.pattern}}</div>}

                </div>}


            </div>

<div class="mb-3">
  <label>Network Provider <span class="required">*</span></label>

  <ng-select
    [items]="gatewayProvidersList"
    formControlName="networkProvider"
    bindLabel="name"
    bindValue="name"
    [multiple]="false"
    [clearable]="false"
    placeholder="Select Network Provider">
  </ng-select>

  @if (submitted && gatewayControls['networkProvider'].errors) {
    <div class="invalid-feedback">
      @if (gatewayControls['networkProvider'].errors['required']) {
        <div>Network Provider is required.</div>
      }
    </div>
  }
</div>


        </form>
    </div>
    <div class="modal-footer">
        @if(gatewayUpdateData?.id){
        <button type="button" class="btn btn-primary waves-effect waves-light"
            (click)="saveGateway('Update')">Update</button>}
        @else{
        <button type="button" class="btn btn-primary waves-effect waves-light" (click)="saveGateway('Create')">Save
            Gateway</button>}

        <!-- Add Gateways modal End  -->
    </div>
</div>
<!-- </div> -->